<template>
  <a-tag v-bind="attrs" :class="[bem.b(), bem.is(props.shape)]">
    <slot>{{ props.label }}</slot>

    <!-- 图标 -->
    <template v-if="$slots['icon'] || icon.iconName" #icon>
      <slot v-if="$slots['icon']" name="icon" />
      <ll-icon
        v-else-if="icon.iconName"
        v-bind="icon"
        :style="{ order: iconDirection === 'left' ? 0 : 1 }"
      />
    </template>

    <!-- 其余插槽 -->
    <template
      v-for="item in Object.keys($slots).filter(
        (k) => k !== 'default' && k !== 'icon',
      )"
      :key="item"
      #[item]="data"
    >
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-tag>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'

import { createNamespace } from '@ll-plus/utils'
import { tagProps } from './tag'

defineOptions({ name: 'LlTag', inheritAttrs: false })

const props = defineProps(tagProps)

const bem = createNamespace('tag')

const attrs = useAttrs()
</script>
